// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1973K","savePackageButton":"ClientWallet_savePackageButton__alTv3"};